import { render, staticRenderFns } from "./distributionPaper.vue?vue&type=template&id=0f13b6b5&scoped=true&"
import script from "./distributionPaper.vue?vue&type=script&lang=js&"
export * from "./distributionPaper.vue?vue&type=script&lang=js&"
import style0 from "./distributionPaper.vue?vue&type=style&index=0&id=0f13b6b5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f13b6b5",
  null
  
)

export default component.exports